import { flushSync } from "react-dom";

export type AlphaStepDirection = "back" | "forward";

export function startAlphaStepTransition(
  update: () => void,
  direction: AlphaStepDirection = "forward",
): void {
  if (!document.startViewTransition) {
    update();

    return;
  }

  document.documentElement.dataset.alphaStepDirection = direction;

  document
    .startViewTransition(() => flushSync(update))
    .finished.catch(() => {})
    .finally(() => {
      delete document.documentElement.dataset.alphaStepDirection;
    });
}
